import { getApiBaseUrl } from '~/utils/apiUrl'

export default function ({ $axios }) {
  $axios.defaults.withCredentials = true

  // 매 요청마다 baseURL을 동적으로 설정
  $axios.interceptors.request.use((config) => {
    config.baseURL = getApiBaseUrl()
    return config
  })
}
